<template>
    <div>
      <div class="modal hide fade" id="modalGetProductGrid" tabindex="-1" role="dialog" aria-labelledby="modalGetProductGrid" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Product Lists</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="table-responsive">
                    <div class="form-inline">
                      <div class="form-group">
                        <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                      </div>
                      <nav aria-label="Page navigation example" class="pull-right">
                          <ul class="pagination">
                              <li class="page-item">
                                  <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                      <i class="fa fa-angle-left" aria-hidden="true"></i>
                                  </a>
                              </li>
                              <li class="page-item">
                                  <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                      <i class="fa fa-angle-right" aria-hidden="true"></i>
                                  </a>
                              </li>
                          </ul>
                      </nav>
                    </div>
                    <div class="row">
                      <div class="col-6" v-for="i in filterData" :key="i.id">
                        <div class="card" style="border: 1px solid #ccc; cursor: pointer;" @click="selectProduct(i)" data-dismiss="modal">
                          <div class="card-body">
                            <span class="text-primary font-12">{{ i.product_no }} </span>
                            <p class="text-primary font-18">{{ i.product_name }}</p>
                            <ul>
                            <!-- <li>Category: <b>{{ i.category }}</b></li> -->
                            <!-- <li>Type: {{ i.type_id }}</li> -->
                            <!-- <li>Price: Rp. <span class="text-secondary">{{ i.price | currency }}</span></li> -->
                            <!-- <li>Qty: <span class="text-secondary">0.0 {{ i.uom_id }}</span></li> -->
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <pre>{{ priceid }}</pre> -->
              <!-- <pre>{{ branch }}</pre> -->
              <!-- <pre>{{ date }}</pre> -->
              <!-- <pre>{{ status }}</pre> -->
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { mapState } from 'vuex'

export default {
  name: 'SalesProductGridModal',
  props: ['sales', 'date', 'status'],
  data () {
    return {
      filterSearchBy: 'product_name',
      load: false,
      wh_no: 'WH0001',
      categoryProduct: '',
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      title: [{
        name: 'Product No',
        prop: 'product_no'
      }, {
        name: 'Name',
        prop: 'product_name'
      }, {
        name: 'Qty',
        prop: 'cost_qty'
      }, {
        name: 'Uom',
        prop: 'uom_id'
      }],
      selectAll: false,
      selected: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      priceListGroup: state => state.priceLists.priceListGroup,
      productCategoryList: state => state.products.productCategoryList,
      warehouseList: state => state.warehouses.warehouseList,
      productListAll: state => state.products.productListSelect,
      rowsTable: state => state.data.rowsTable
    }),
    getPrice: function () {
      var array = this.productListAll
      var pl = null
      for (let i = 0; i < array.length; i++) {
        pl = array[i]
      }
      return pl
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.productListAll.length
      } else {
        count = this.productListAll
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.productListAll.length
      } else {
        count = this.productListAll
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        // this.currentPage = 1
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.productListAll.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (this.filterSearchBy === 'product_name') {
              if (d.product_name.toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                return d
              }
            } else if (this.filterSearchBy === 'product_no') {
              if (d.product_no.toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                return d
              }
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    selectProduct (product) {
      this.$emit('selectProduct', product)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select: function (id) {
      var product = this.productListAll.find(d => d.id === id)
      product.warehouse_no = this.wh_no
      this.$emit('selectProduct', product)
      // if (product.cost_qty > 0) {
      //   product.warehouse_no = this.wh_no
      //   this.$emit('selectProduct', product)
      // } else {
      //   if (this.status === 'order' || this.status === 'workshop') {
      //     product.warehouse_no = this.wh_no
      //     this.$emit('selectProduct', product)
      //   } else {
      //     this.$swal('Error', 'Stok kosong, silahkan periksa Product Summary terlebih dahulu', 'error')
      //   }
      // }
    }
  },
  mounted () {
    // this.loadList()
  }
}
</script>
